const Styles = (theme: any) => ({
  uploadFileContainer: {
    padding: '16px',
  },
  disableSampleText: {
    '& a': {
      cursor: 'not-allowed !important',
      color: `${theme.colors.border} !important`,
    },
  },
});

export default Styles;
